export default {
  programBehaviourGroups:
    (state) => state.programBehaviourDataGroupCache,

  programBehaviourGroupItems:
    (state) => state.programBehaviourDataItemCache,
};
